import { RegistrarCheckoutComponent } from "./page/registrar-checkout/registrar-checkout.component";
import { RegistrarComponent } from "./page/registrar.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RegistrarFormComponent } from "./page/registrar-form/registrar-form.component";
import { RegistrarThirdpartyComponent } from "./page/registrar-thirdparty/registrar-thirdparty.component";
import { RegistrarViaInviteComponent } from "./page/registrar-via-invite/registrar-via-invite.component";

export const routes: Routes = [
    {
        path: "",
        component: RegistrarComponent,
        children: [
            {
                path: "",
                redirectTo: "form",
                pathMatch: "full"
            },
            {
                path: "form",
                component: RegistrarFormComponent
            },
            {
                path: "thirdparty",
                component: RegistrarThirdpartyComponent
            },
            {
                path: "via-invite",
                component: RegistrarViaInviteComponent
            },
            {
                path: "payment",
                component: RegistrarCheckoutComponent
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class RegistrarRoutingModule {}
